import React from "react";
import ProfileForm from "@/components/ProfileForm";
import { useAuth } from "@/contexts/AuthContext";

export default function WelcomeProfileModal() {
  const { user, checkAuth } = useAuth();

  // Only render if the user is logged in and hasn't seen the welcome
  if (!user || user.profile_seen) return null;

  const close = async () => {
    await checkAuth();
  };

  return (
    <div
      data-testid="welcome-profile-modal"
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#2D2926]/40 backdrop-blur-sm"
    >
      <div className="bg-[#FBF9F6] max-w-lg w-full rounded-3xl shadow-2xl border border-[#E6E2D8] max-h-[92vh] overflow-y-auto">
        <div className="px-8 pt-8 pb-2">
          <h2 className="font-serif text-3xl text-[#2D2926] leading-tight">
            Tell us a little about yourself
          </h2>
          <p className="mt-3 text-sm text-[#6B655D] leading-relaxed">
            Answer as many or as few as you like — you can always come back and
            fill more in. This is used to make conversations feel more like you.
            We don't share it, sell it, or train on it.
          </p>
        </div>
        <div className="px-8 pb-8 pt-4">
          <ProfileForm
            initial={user.profile || {}}
            submitLabel="Save & continue"
            compact
            onSaved={close}
            onSkip={close}
          />
        </div>
      </div>
    </div>
  );
}
